package diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme

import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/**
 * Coarse responsive width buckets (Material 3 window-size-class breakpoints). Screens classify their
 * available width — typically via `BoxWithConstraints { windowWidthClassFor(maxWidth) }` — and adapt
 * layout (single vs. multi-column, centered max width) instead of stretching edge-to-edge on desktop/
 * web. Kept dependency-free (no material3-window-size-class) so it works on every KMP target.
 */
enum class WindowWidthClass { Compact, Medium, Expanded }

/** Breakpoints between the buckets (M3): < 600dp compact, < 840dp medium, else expanded. */
val MediumWidthBreakpoint: Dp = 600.dp
val ExpandedWidthBreakpoint: Dp = 840.dp

fun windowWidthClassFor(width: Dp): WindowWidthClass = when {
    width < MediumWidthBreakpoint -> WindowWidthClass.Compact
    width < ExpandedWidthBreakpoint -> WindowWidthClass.Medium
    else -> WindowWidthClass.Expanded
}
